import { Box } from "@otrium/core";
import { Skeleton } from "src/atoms/Skeleton";

const ShippingMethodsSkeleton = ({
  itemHeight,
}: {
  itemHeight?: number | string;
}): JSX.Element => (
  <Box>
    <Box height={itemHeight || "100%"} width="100%" mb={3}>
      <Skeleton />
    </Box>
    <Box height={itemHeight || "100%"} width="100%" mb={3}>
      <Skeleton />
    </Box>
    <Box height={itemHeight || "100%"} width="100%" mb={3}>
      <Skeleton />
    </Box>
  </Box>
);

export default ShippingMethodsSkeleton;
